import React from "react";
import ReactDOMServer from "react-dom/server";

function InvoiceServicesSectionStatic(data) {
  const staticContent = (
    <div className="w-full flex flex-col mt-10 px-4">
      <div className="w-full items-center justify-between flex mb-5">
        <div className="w-1/3">
          <span className="font-semibold text-xl">Services</span>
        </div>
        <div className="w-32 flex justify-end">
          <span className="text-xl text-gray-600 text-right">Quantity</span>
        </div>
        <div className="w-32 flex justify-end">
          <span className="text-xl text-gray-600 text-right">Price</span>
        </div>
        <div className="w-32 flex justify-end">
          <span className="text-xl text-gray-600 text-right">Total</span>
        </div>
      </div>

      {data?.services?.map((item, itemIndex) => (
        <div
          className="w-full items-center justify-between flex mb-3"
          key={itemIndex}
        >
          <div className="w-1/3 flex flex-col">
            <span className="text-base mb-2">{item?.title}</span>
            <div className="flex flex-1 flex-col">
              <ul className="list-disc ml-10">
                {item?.details?.map((detail, detailIndex) => (
                  <li className="text-base mt-1" key={detailIndex}>
                    {detail}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="w-32 text-right">
            <span className="text-base text-gray-600">{item?.quantity}</span>
          </div>
          <div className="w-32 text-right">
            <span className="text-base text-gray-600">{item?.price}</span>
          </div>
          <div className="w-32 text-right">
            <span className="text-base text-gray-600">{item?.total}</span>
          </div>
        </div>
      ))}

      <div className="mt-10 w-full flex items-center">
        <hr className="border-gray-300 flex flex-1" />
        <div className="w-fit rounded-xl px-6 py-2 bg-gray-100 flex justify-between items-center gap-4">
          <span className="text-lg text-gray-600 text-right">Total</span>
          <span className="text-2xl font-bold text-right">{data?.total}</span>
        </div>
      </div>
    </div>
  );

  return ReactDOMServer.renderToStaticMarkup(staticContent);
}

export default InvoiceServicesSectionStatic;
